import axiosInstance from "api/axiosInstance";
import { facilityAction } from "./facility-slice";
import SAlert from "components/Alert";
import exportAxiosInstance from "api/exportAxiosInstance";
import FileSaver from "file-saver";

//  Get Facilities
export const getFacilities =
  (
    url,
    pageNumber = 10,
    according = { order: "desc", name: "id" },
    search = null
  ) =>
  (dispatch) => {
    dispatch(facilityAction.setLoading(true));
    url = url || "/v1/facilities";
    axiosInstance
      .get(url, {
        params: {
          pageNumber: pageNumber,
          according: according,
          search: search,
        },
      })
      .then((response) => {
        if (response) {
          dispatch(facilityAction.setError(null));
          dispatch(facilityAction.setData(response.data));
          dispatch(facilityAction.setLoading(false));
        }
      })
      .catch((error) => {
        dispatch(facilityAction.setLoading(false));
        console.log(error);
      });
  };

//Delete Facility
export const deleteFacility = (id) => (dispatch) => {
  dispatch(facilityAction.setLoading(true));
  axiosInstance
    .delete(`/v1/facilities/${id}`)
    .then((response) => {
      dispatch(getFacilities());
      SAlert({ title: "Success", text: "Facility successfully delete" });
      dispatch(facilityAction.setError(null));
      dispatch(facilityAction.setLoading(false));
    })
    .catch((error) => {
      dispatch(warehouseAction.setLoading(false));
      console.log(error);
    });
};

// Store Facility
export const storeFacility = (data, navigate) => (dispatch) => {
  dispatch(facilityAction.setLoading(true));
  axiosInstance
    .post("/v1/facilities", data)
    .then((response) => {
      navigate("/facilities");
      SAlert({ title: "Success", text: "Facility successfully inserted" });
      dispatch(facilityAction.setError(null));
      dispatch(facilityAction.setLoading(false));
    })
    .catch((err) => {
      dispatch(facilityAction.setLoading(false));
      dispatch(facilityAction.setError(err?.response?.data?.errors));
    });
};

// Update Facility
export const updateFacility = (id, data, navigate) => (dispatch) => {
  dispatch(facilityAction.setLoading(true));
  axiosInstance
    .put(`/v1/facilities/${id}`, data)
    .then((respnose) => {
      navigate("/facilities");
      SAlert({ title: "Success", text: "Facility successfully updated" });
      dispatch(facilityAction.setError(null));
      dispatch(facilityAction.setLoading(false));
    })
    .catch((error) => {
      dispatch(facilityAction.setLoading(false));
      dispatch(facilityAction.setError(error?.response?.data?.errors));
    });
};

// Get Facility By ID
export const getByIdFacility = (id) => (dispatch) => {
  dispatch(facilityAction.setLoading(true));
  axiosInstance
    .get(`/v1/facilities/${id}`)
    .then((respnose) => {
      dispatch(facilityAction.setError(null));
      dispatch(facilityAction.setLoading(false));
      dispatch(facilityAction.setFacililty(respnose.data));
    })
    .catch((error) => {
      dispatch(facilityAction.setLoading(false));
      console.log(error);
    });
};

// Export Facility
export const exportFacilities = (search) => (dispatch) => {
  dispatch(
    facilityAction.setExportStatus({
      loading: true,
      error: null,
    })
  );
  exportAxiosInstance
    .get("/v1/facility-export", {
      params: { search },
    })
    .then((response) => {
      if (response) {
        const dataBlob = new Blob([response?.data], {
          type: "application/pdf,",
        });
        FileSaver.saveAs(dataBlob, `Facility-${Math.random().toString()}.xlsx`);
        dispatch(
          facilityAction.setExportStatus({
            loading: false,
            error: null,
          })
        );
      }
    })
    .catch((error) => {
      dispatch(
        facilityAction.setExportStatus({
          loading: false,
          error: error?.response?.errors,
        })
      );
      console.log(error);
    });
};
